module.exports = __webpack_public_path__ + "img/2022_dodge-durango-01.b4b77669.jpg";